import React, { memo } from 'react';

import { Box, Typography } from '@mui/material';
import PropTypes from 'prop-types';

import { ListItemStatus } from '../../../BotMessage.constants';

import { listItemLabelStyles, listItemStyles, listItemTextStyles } from './ListContent.styles';

const ListItem = ({ item }) => {
  const isError = item.status === ListItemStatus.ERROR;

  return (
    <Box sx={listItemStyles}>
      <Typography color="text.secondary" sx={listItemLabelStyles} variant="regular14">
        {item.label}:
      </Typography>
      <Typography
        color={isError ? 'text.error' : 'text.primary'}
        sx={listItemTextStyles}
        variant="regular14"
      >
        {item.text}
      </Typography>
    </Box>
  );
};

ListItem.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired,
    status: PropTypes.oneOf(Object.values(ListItemStatus)).isRequired,
  }).isRequired,
};

export default memo(ListItem);
